import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import PracticeBoard from './PracticeBoard';

import {
    getPracticeData,
    getPracticeResurveyData,
    getPracticeBuData,
    getScoreData,
    getPptData,
    setPracticeDisplay,
    updateFilters,
    resetPracticeBuDataFetched,
    getSinglePastReport,
    getComparisonYrPracticeData,
    getBuData,
    getDemographics,
    getBenchmarks,
    getReSurveyData,
    resetReSurveyDataFetched,
} from '../actions';
import {
    updatePracticeBuFilters,
    getReport,
    getRawPptData,
    updateEntireOrganizationComparison,
} from '../../Reports/actions';
import { selectReportsData, selectReportsFetched } from '../../UserReports/selector';

import {
    selectScoreData,
    selectScoreDataFetched,
    selectPracticeData,
    practiceDataFetched,
    selectPracticeResurveyData,
    selectApiParams,
    selectApiCount,
    selectFiltersApplied,
    getErrorInfo,
    selectFilters,
    selectPracticeToDisplay,
    selectPracticeBuData,
    selectPracticeBuDataFetched,
    selectPastReport,
    selectPracticeDataCompYr,
    selectProjects,
    selectProjectsFetched,
    selectBuData,
    selectBuDataFetched,
    selectReSurveyData,
    selectReSurveyDataFetched,
} from '../selector';

import { getDefaultSettings } from '../../Login/selector';
import {
    selectPracticeFilters,
    selectReportError,
    selectPracticeRankingEntireOrganization,
} from '../../Reports/selector';
import { getReports } from '../../UserReports/actions';

const stateToProps = createStructuredSelector({
    scoreData: selectScoreData(),
    scoreDataFetched: selectScoreDataFetched(),
    practiceData: selectPracticeData(),
    practiceDataFetched: practiceDataFetched(),
    practiceResurveyData: selectPracticeResurveyData(),
    apiParams: selectApiParams(),
    apiLoadingCount: selectApiCount(),
    activeFilter: selectFiltersApplied(),
    errorInfo: getErrorInfo(),
    filters: selectFilters(),
    practiceToDisplay: selectPracticeToDisplay(),
    defaultSettings: getDefaultSettings(),
    practiceFilters: selectPracticeFilters(),
    isEntireOrganizationSelected: selectPracticeRankingEntireOrganization(),
    practiceBuData: selectPracticeBuData(),
    practiceBuDataFetched: selectPracticeBuDataFetched(),
    reportError: selectReportError(),
    singlePastReport: selectPastReport(),
    practiceDataCompYr: selectPracticeDataCompYr(),
    projects: selectProjects(),
    projectsFetched: selectProjectsFetched(),
    buData: selectBuData(),
    buDataFetched: selectBuDataFetched(),
    reSurveyData: selectReSurveyData(),
    reSurveyDataFetched: selectReSurveyDataFetched(),
    reportsData: selectReportsData(),
    reportsDataFetched: selectReportsFetched(),
});

const dispatchToProps = {
    getPracticeData,
    getPracticeResurveyData,
    getPracticeBuData,
    updatePracticeBuFilters,
    updateEntireOrganizationComparison,
    getPptData,
    setPracticeDisplay,
    getScoreData,
    updateFilters,
    resetPracticeBuDataFetched,
    getReport,
    getRawPptData,
    getSinglePastReport,
    getComparisonYrPracticeData,
    getBuData,
    getBenchmarks,
    getDemographics,
    getReSurveyData,
    resetReSurveyDataFetched,
    getReports,
};

export default connect(stateToProps, dispatchToProps)(PracticeBoard);
